import Swiper, {Navigation, Autoplay} from 'swiper';

const filterOptions = {
    modules: [Navigation, Autoplay],
    loop: false,
    spaceBetween: 15,
    speed: 1000,
    grabCursor: true,
    slidesPerView: 1,
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
    navigation: {
        nextEl: document.querySelector('.more-resources__container .swiper-button-next'),
        prevEl: document.querySelector('.more-resources__container .swiper-button-prev'),
    },
    breakpoints: {
        992: {
            slidesPerView: 3,
            spaceBetweenSlides: 35
        },
        767: {
            slidesPerView: 2,
            spaceBetweenSlides: 25
        },
    }
};

let filterSwiper = new Swiper(document.querySelector('.more-resources__swiper'), filterOptions);
$(".resources-item").mouseenter(function () {
    filterSwiper.autoplay.stop();
})
    .mouseleave(function () {
        filterSwiper.autoplay.start();
    });